import React from 'react';
import { TwentyTwentysixSiteLayout } from './TwentyTwentysixSiteLayout';
import { TwentyTwentysixRoutes } from '../routes/twentyTwentysixRoutes';
import '../styles/tokens.css';
import '../styles/globals.css';

export function TwentyTwentysixSiteApp() {
  return (
    <TwentyTwentysixSiteLayout>
      <TwentyTwentysixRoutes />
    </TwentyTwentysixSiteLayout>
  );
}

export default TwentyTwentysixSiteApp;
